import axios from 'axios';
import scrollToElement from 'scroll-to-element';
import defer from 'lodash/defer';

export default class PartnerForm {
  constructor() {
    this.$element = document.querySelector('.c-partner-form');

    if (!this.$element) return;

    // DOM
    this.$form = document.querySelector('.c-partner-form__form');
    this.$header = document.querySelector('.c-header');
    this.$main = document.querySelector('.c-partner-form__main');
    this.$success = document.querySelector('.c-partner-form__submit--success');
    this.$error = document.querySelector('.c-partner-form__submit--error');
    this.$emailField = this.$form.querySelector('input[name="business_email"]');
    this.$emailFieldMsg = this.$form.querySelector('input[name="business_email"] + .c-partner-form__error');

    // Variables
    this.ajaxAction = 'partners_form';
    this.hasErrors = false;

    // Functions
    this.onSubmit = this.onSubmit.bind(this);
    this.validateEmail = this.validateEmail.bind(this);

    // Events
    this.$form?.addEventListener('submit', this.onSubmit.bind(this));
    this.$emailField?.addEventListener('blur', this.validateEmail.bind(this));
  }

  /**
   * @function onSubmit
   * @param {Event} e
   * Fired on form submit
   */
  onSubmit(e) {
    e.preventDefault();

    // Form can't submit with errors
    if (this.hasErrors === true) return;

    // Get the FormData
    const fields = document.querySelectorAll('[data-form-item]');
    const params = new URLSearchParams();

    // Set the action
    params.append('action', this.ajaxAction);

    // Build the params from field names
    fields.forEach((field) => {
      params.append(field.getAttribute('name'), field.value);
    });

    axios
      .post(`${window.site.api.ajax}?action=${this.ajaxAction}`, params)
      .then(res => this.onSuccess(res))
      .catch(res => this.onError(res));
  }

  /**
   * @function onError
   * @param {Object} res
   */
  onError() {
    this.$main.classList.add('is-hidden');
    this.$success.classList.remove('is-visible');
    this.$error.classList.add('is-visible');

    defer(() => {
      this.scroll();
    });
  }

  /**
   * @function onSuccess
   * @param {Object} res
   */
  onSuccess(res) {
    if (res.errors) {
      return this.onError(res);
    }

    this.$main.classList.add('is-hidden');
    this.$success.classList.add('is-visible');

    defer(() => {
      this.scroll();
    });

    return true;
  }

  /**
   * @function scroll
   * Scrolls to the top of the form
   */
  scroll() {
    const offset = this.$header.offsetHeight;

    scrollToElement(this.$element, {
      offset: -offset,
      ease: 'out-expo',
      duration: 500,
    });
  }

  /**
   * @function validateEmail
   * Validates a business email
   */
  validateEmail() {
    if (/\@(gmail|aol|yahoo|icloud|me|hotmail|msn|live|rediffmail|ymail|outlook|inbox|gmx|mail|protonmail)\.com/.test(this.$emailField.value)) {
      this.$emailFieldMsg.classList.add('is-visible');
      this.hasErrors = true;
    } else {
      this.$emailFieldMsg.classList.remove('is-visible');
      this.hasErrors = false;
    }
  }
}
